import localForage from "localforage";
import helpers from "@/utils/helpers";

export const store = localForage.createInstance({
  name: "firstClub",
  storeName: "app",
});

const mapStateForCache = state => {
  return {
    locale: state.locale,
    security: state.security,
    customers: {
      current: state.customers.current,
    },
  };
};

export const setState = state => {
  const cachedState = mapStateForCache(state);
  return store.setItem("state", cachedState);
};

export const getState = () => store.getItem("state");

export const getStateValue = async path => {
  const state = await store.getItem("state");
  return helpers.get(state, path);
};

export const deleteState = () => store.removeItem("state");

export default {
  store,
  setState,
  getState,
  getStateValue,
  deleteState,
};
